import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { useBrowserDetection } from "../../hooks/useBrowserDetection";
import { useUniqueId } from "../../hooks/useUniqueId";
import * as Styled from "./Select.styled";
import { getDisplayLabel } from "./getDisplayLabel";
export const SelectToggle = forwardRef((props, ref) => {
    const { children, disabled, labelId, onClick, options, hasStatus, palette, placeholder, renderSelectedOption, required, selectedValue, selectedOption, id: idProp, ...otherProps } = props;
    const id = useUniqueId("aui-select-toggle-", idProp);
    const handleKeyDown = (event) => {
        if (event.key === "ArrowUp" || event.key === "ArrowDown") {
            event.preventDefault();
            onClick && onClick();
        }
    };
    const { isMac, isFirefox } = useBrowserDetection();
    // Mac VoiceOver mangles value announcement for some reason and Firefox cannot announce value at all
    const canUseCombobox = !(isMac || isFirefox);
    // TODO: detect somehow when user mistakenly passes same value to Field and labelId
    const buttonLabels = labelId ? `${labelId} ${id}` : undefined;
    return (_jsxs(Styled.Toggle, { type: "button", ref: ref, hasStatus: hasStatus, onClick: disabled ? undefined : onClick, onKeyDown: disabled ? undefined : handleKeyDown, "data-testid": "SelectToggle", "aria-disabled": disabled, "aria-required": required || undefined, "aria-labelledby": canUseCombobox ? labelId : buttonLabels, role: canUseCombobox ? "combobox" : undefined, tabIndex: disabled ? -1 : 0, id: id, ...otherProps, isOpen: otherProps["aria-expanded"], palette: palette, children: [_jsx(Styled.TextWrapper, { children: children
                    ? children
                    : getDisplayLabel({
                        options,
                        placeholder, // TODO use aria-placeholder for better compat with combobox?
                        selectedValue,
                        selectedOption,
                        renderSelectedOption
                    }) }), _jsx(Styled.Arrow, { isOpen: otherProps["aria-expanded"], "aria-hidden": "true" })] }));
});
SelectToggle.displayName = "SelectToggle";
